export const AllowanceType = Object.freeze({
  CUSTOM_RESERVATION_TIME: "CUSTOM_RESERVATION_TIME",
  VISIBILITY: "VISIBILITY",
  SEMI_PUBLIC: "SEMI_PUBLIC",
  CUSTOM_PERCENTAGE_PRICE: "CUSTOM_PERCENTAGE_PRICE",
});

export const DEFAULT_ALLOWANCES = [AllowanceType.VISIBILITY];

export const normalizeAllowances = (allowances = []) => {
  if (!Array.isArray(allowances)) return [];

  return Array.from(new Set(allowances.filter(Boolean)));
};

export const hasDiscountAllowance = (allowances = []) => {
  return normalizeAllowances(allowances).includes(
    AllowanceType.CUSTOM_PERCENTAGE_PRICE
  );
};

export const isDiscountOnlyAllowanceSet = (allowances = []) => {
  const normalized = normalizeAllowances(allowances).filter(
    (allowance) => allowance !== AllowanceType.VISIBILITY
  );

  return (
    normalized.length > 0 &&
    normalized.every((allowance) => allowance === AllowanceType.CUSTOM_PERCENTAGE_PRICE)
  );
};

export const prepareAllowancesForSubmit = (allowances = []) => {
  return normalizeAllowances(allowances);
};

export const applyAllowancesChange = (
  form,
  allowances = [],
  extraFieldsToValidate = []
) => {
  const normalized = normalizeAllowances(allowances);

  form.setFieldsValue({ allowances: normalized });

  if (!hasDiscountAllowance(normalized)) {
    form.setFieldsValue({ percentageDiscountValue: undefined });
  }

  if (!normalized.includes(AllowanceType.CUSTOM_RESERVATION_TIME)) {
    form.setFieldsValue({ reservationTime: undefined });
  }

  const fieldsToValidate = Array.from(
    new Set([
      "companyID",
      "percentageDiscountValue",
      "reservationTime",
      "stations",
      ...extraFieldsToValidate,
    ])
  );

  form.validateFields(fieldsToValidate, { force: true });

  return normalized;
};

/**
 * Validates the conflict rule between addOnQr and allowExternalCharge.
 * Rule: if addOnQr is true, allowExternalCharge MUST be true.
 * Returns the sanitized values ensuring consistency.
 */
export const enforceAddOnQrExternalChargeRule = (payload) => {
  if (payload.addOnQr === true && payload.allowExternalCharge === false) {
    payload.allowExternalCharge = true;
  }
  return payload;
};

export const buildVisibilityGroupSubmissionPayload = (form, payload = {}) => {
  const sanitizedPayload = { ...payload };
  const allowances = prepareAllowancesForSubmit(payload.allowances);

  if (form.isFieldTouched("allowances")) {
    sanitizedPayload.allowances = allowances;
  } else {
    delete sanitizedPayload.allowances;
  }

  if (hasDiscountAllowance(allowances)) {
    sanitizedPayload.percentageDiscountValue =
      Number(((sanitizedPayload?.percentageDiscountValue || 0) / 100).toFixed(4));
  } else {
    delete sanitizedPayload.percentageDiscountValue;
  }

  if (!allowances.includes(AllowanceType.CUSTOM_RESERVATION_TIME)) {
    delete sanitizedPayload.reservationTime;
  }

  enforceAddOnQrExternalChargeRule(sanitizedPayload);

  return {
    payload: sanitizedPayload,
    allowances,
  };
};
